






















































































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import XButton from "../SimpleButton.vue";
import moment from "moment";
import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue';

@Component({
  components: {
    VueTimepicker,
    XButton,
  },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },
  computed: {
    dateFormatted() {
      return this.date && moment(this.date).format("DD.MM.YYYY") || "";
    },
    hasError() {
      return this.errorMessages.length > 0;
    },
    value: {
      get: function() {
        return this.modelValue;
      },
      set: function(v) {
        const value = v || "";
        if (value == "") {
          this.date = "";
          this.time = {HH: "", mm: ""};
        } else {
          let dateTime = moment(value);
          this.date = dateTime.format("YYYY-MM-DD");
          this.time = {HH: dateTime.format("hh"), mm: dateTime.format("mm")};
        }
      }
    }
  },
  data() {
    return {
      date: null,
      time: null,
    };
  },
})
class DateTimeCustomField extends Vue {
  [x: string]: any;

  @Prop({ default: "" }) readonly fieldName!: string;
  @Prop({ default: false }) readonly required!: boolean;
  @Prop({ default: false }) readonly disabled!: boolean;
  @Prop({ default: () => [] }) readonly errorMessages!: [];
  @Prop({ default: 5 }) readonly minuteInterval!: number;

  isDropdownDisplayed = false;

  @Watch("time")
  timeChanged() {
    const date = this.date || "";
    const HH = (this.time?.HH || "").replace(/^\D+/g, "");
    const mm = (this.time?.mm || "").replace(/^\D+/g, "");
    let value = "";
    if (date != "" && HH != "" && mm != "") {
      value = moment(`${date} ${HH}:${mm}`).format("YYYY-MM-DDTHH:mm:ss.000");
    }
    this.$emit('update:modelValue', value);
  }

  public applyDateChanges() {
    this.timeChanged();
    this.isDropdownDisplayed = false;
  }

  public resetDateChanges() {
    this.date = "";
    this.applyDateChanges();
  }
}

export default DateTimeCustomField;
